import { render, staticRenderFns } from "./AverageTimeWidget.vue?vue&type=template&id=2a4a7016&scoped=true&"
import script from "./AverageTimeWidget.vue?vue&type=script&lang=js&"
export * from "./AverageTimeWidget.vue?vue&type=script&lang=js&"
import style0 from "./AverageTimeWidget.vue?vue&type=style&index=0&id=2a4a7016&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a7016",
  null
  
)

export default component.exports